"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const ResponseError_1 = require("../../../Components/Http/Error/ResponseError");
class SchemaError extends ResponseError_1.default {
    constructor(response, schema) {
        super('Response does not match Schema', response);
        this.schema = schema;
    }
}
exports.default = SchemaError;
//# sourceMappingURL=SchemaError.js.map